import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { RDDarkService } from './../dark.service';

@Component({
  selector: 'rd-modal',
  template: `<div class="modalContainer" [class.open]="isOpen()"
 [class.rdDark]="dark" (click)="closeModal()">
  <div class="modalPanel" [style.width.%]="width" [style.maxHeight.%]="maxHeight" (click)="clickOnModal($event)">
    <ng-content></ng-content>
  </div>
</div>
`,
  styles: [`.modalContainer{--background-color:rgba(241, 241, 241, 0.8);--text-color:black;position:fixed;top:0;left:0;width:100%;height:100%;background-color:var(--background-color);color:var(--text-color);display:none;z-index:10}.modalContainer.open{display:block}.modalContainer .modalPanel{position:absolute;top:50%;left:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%);background-color:#fff;box-shadow:0 2px 5px 0 rgba(0,0,0,.16),0 2px 10px 0 rgba(0,0,0,.12);overflow-x:hidden;overflow-y:auto}.modalContainer.rdDark{--background-color:rgba(7, 56, 76, 0.8);--text-color:white}`]
})
export class RDModalComponent implements OnInit {

  @Input() width = 50;
  @Input() maxHeight = 80;

  @Output() closedModal: EventEmitter<any> = new EventEmitter();

  private open = false;
  public dark = false;

  constructor(private darkService: RDDarkService) { }

  ngOnInit() {
    this.darkService.getDarkElement().subscribe(() => {
      this.dark = this.darkService.isDark();
    });
    this.dark = this.darkService.isDark();
  }

  openModal() {
    this.open = true;
  }

  closeModal() {
    this.open = false;
    this.closedModal.emit();
  }

  isOpen() {
    return this.open;
  }

  clickOnModal(event) {
    event.stopPropagation();
  }
}
